(() => {
  const viewerInstances = new WeakMap();

  function getGalleryImages(gallery) {
    return Array.from(gallery.querySelectorAll('.product__media-item img')).filter(
      (image) => image.currentSrc || image.src
    );
  }

  function getImageUrl(image) {
    return image.dataset.original || image.currentSrc || image.src;
  }

  function initializeGallery(gallery) {
    if (!gallery || viewerInstances.has(gallery) || typeof window.Viewer !== 'function') return;

    let updateTimer;

    const viewer = new window.Viewer(gallery, {
      url: getImageUrl,
      filter(image) {
        return image.matches('.product__media-item img');
      },
      backdrop: true,
      button: true,
      className: 'sleep-city-pdp-viewer',
      container: 'body',
      focus: true,
      keyboard: true,
      loop: true,
      movable: true,
      navbar: true,
      rotatable: false,
      scalable: false,
      slideOnTouch: true,
      title: true,
      toolbar: {
        zoomIn: 1,
        zoomOut: 1,
        oneToOne: 1,
        reset: 1,
        prev: 1,
        next: 1,
        rotateLeft: 0,
        rotateRight: 0,
        flipHorizontal: 0,
        flipVertical: 0,
      },
      tooltip: true,
      transition: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      zoomable: true,
      zoomOnTouch: true,
      zoomOnWheel: true,
    });

    const openViewer = (event) => {
      const opener = event.target.closest('.product__modal-opener');
      if (!opener || !gallery.contains(opener)) return;

      const selectedImage = opener.querySelector('img');
      const images = getGalleryImages(gallery);
      const selectedIndex = images.indexOf(selectedImage);

      if (!selectedImage || selectedIndex < 0) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      viewer.view(selectedIndex);
    };

    gallery.addEventListener('click', openViewer, true);

    const observer = new MutationObserver(() => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => viewer.update(), 100);
    });

    observer.observe(gallery, {
      childList: true,
      subtree: true,
    });

    viewerInstances.set(gallery, {
      destroy() {
        window.clearTimeout(updateTimer);
        observer.disconnect();
        gallery.removeEventListener('click', openViewer, true);
        viewer.destroy();
      },
    });
  }

  function initializeViewers(root = document) {
    if (typeof window.Viewer !== 'function') return;

    root
      .querySelectorAll('product-info.sc-fav-page .product__media-list')
      .forEach(initializeGallery);
  }

  function boot() {
    initializeViewers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', boot, { once: true });

  document.addEventListener('shopify:section:load', (event) => {
    initializeViewers(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.product__media-list').forEach((gallery) => {
      viewerInstances.get(gallery)?.destroy();
      viewerInstances.delete(gallery);
    });
  });
})();
